import SlideShowGallery_SlideShowTextRightComponent from '../components/NativeGalleries/SlideShowGallery/viewer/skinComps/SlideShowTextRight/SlideShowTextRight.skin';
import SlideShowGallery_SlideShowTextRightController from '../components/NativeGalleries/SlideShowGallery/viewer/SlideShowGallery.controller';


const SlideShowGallery_SlideShowTextRight = {
  component: SlideShowGallery_SlideShowTextRightComponent,
  controller: SlideShowGallery_SlideShowTextRightController
};


export const components = {
  ['SlideShowGallery_SlideShowTextRight']: SlideShowGallery_SlideShowTextRight
};

